<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">{{!selectRol  ? 'Agregar' : 'Editar'}} Rol</label>
      </header>
      <form [formGroup]="formRol" (ngSubmit)="onOperarRol()">
        <div class="form-group">
          <label class="small text-secondary" for="nit">Descripción</label>
          <input id="descripcion" formControlName="descripcion" type="text" class="form-control form-control-sm">
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Estado</label>
          <select class="form-control form-control-sm" id="activo" formControlName="activo"
            [attr.disabled]="!selectRol ? '' : null">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Activo
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              Inactivo
            </option>
          </select>
        </div>
        <div class="form-row mt-5">
          <button type="button" class="btn btn-outline-primary border-0 m-auto" (click)="limpiaRol()">Limpiar</button>
          <button class="btn btn-primary m-auto " [disabled]="!formRol.valid" type="submit">{{!selectRol
            ? 'Agregar' : 'Editar'}}</button>
        </div>
      </form>
    </section>
    <section class="col-9 p-4 mt-5 mb-5">
      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Listado de Roles</label>
        </div>
        <p>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </p>
      </div>

      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Descripción</label>
                  <input id="descripcion" formControlName="descripcion" type="text"
                    class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Estado</label>
                  <select class="form-control form-control-sm" id="activo" formControlName="activo">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Activo
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      Inactivo
                    </option>
                  </select>
                </div>
                <div class="d-flex flex-row">
                  <button type="reset" class="btn btn-outline-primary border-0 m-auto"
                    (click)="limpiar()">Limpiar</button>
                  <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>


      <div class="table-responsive">
        <app-tablas [page] = "paginaActual" [headers]="headerRol" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)"
          class="table-responsive">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.rol_id}}</td>
            <td>{{item.descripcion}}</td>
            <td>{{item.activo ? 'Activo' : 'Inactivo'}}</td>
            <td class="d-flex flex-row">
              <img src="../../../../../../../assets/icons/edit.png" class="pointer" alt="" height="25"
                (click)="onCargarRol(item)">
              <img src="../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25"
                (click)="onEliminarRol(item)">
            </td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>